import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import DocumentTable from "./Document-Table"

const Dashboard = props => {
  const dispatch = useDispatch()
  const themeColor = useSelector(state => state.theme.color)

  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-color", themeColor)
  }, [themeColor])

  useEffect(() => {
  }, [dispatch])

  document.title = "Resource Dashboard - ColdBlock Technologies Inc."

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          /> */}
          <Row>
            <Col lg="12">
              <DocumentTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  getResidentAssessmentsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
